/*!
 * @antv/g
 * @description A core module for rendering engine implements DOM API.
 * @version 6.1.21
 * @date 1/23/2025, 8:34:00 AM
 * @author AntVis
 * @docs https://g.antv.antgroup.com/
 */
export * from '@antv/g-camera-api';
export * from '@antv/g-dom-mutation-observer-api';
export * from '@antv/g-lite';
export * from '@antv/g-web-animations-api';
//# sourceMappingURL=index.esm.js.map
